import { render, staticRenderFns } from "./PWATest.vue?vue&type=template&id=606fc1e2&scoped=true&"
import script from "./PWATest.vue?vue&type=script&lang=js&"
export * from "./PWATest.vue?vue&type=script&lang=js&"
import style0 from "./PWATest.vue?vue&type=style&index=0&id=606fc1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606fc1e2",
  null
  
)

export default component.exports